import { ethers } from "ethers";

export async function getLatestBlock(rpcUrl: string) {
    const provider = new ethers.JsonRpcProvider(rpcUrl);
    const blockNumber = await provider.getBlockNumber();
    return blockNumber;
  }

   const blockTagString = localStorage.getItem("zimulatoor-block-tag");
   type BlockTag = Record<string, { expireAt?: number; blockTag?: number }>;
   export const blockTag: BlockTag = blockTagString ? JSON.parse(blockTagString) : {};